import React from 'react';
import './index.css';

const Tag = (props) => {

    const {className, children, ...other} = props;

    return (
        <div className={`tag ${className}`} {...other}>
            {children}
        </div>
    );
};

export default Tag;